import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'
import type { ComposerTranslation } from 'vue-i18n'
import { Http } from '@/services/http'
import { translateAccessRestrictionLimitType } from '@/views/dashboard/manage/access-restriction/access-restriction-limit-type'

/** 时间视图 / 域名命中列表：策略属性 limit_type（与 accessRestriction 短文案共用 {@link translateAccessRestrictionLimitType}） */
export function formatNetLimitLogLimitType (t: ComposerTranslation, v: unknown): string {
  return translateAccessRestrictionLimitType(t, v as number | string | undefined | null)
}

/** 时间视图 / 域名命中列表：触发动作 `action`（1、2-拦截，3-放行） */
export function formatNetLimitLogAction (t: ComposerTranslation, v: unknown): string {
  const n = Number(v)
  if (n === 1 || n === 2) return t('domainInterceptEvent.actionIntercept')
  if (n === 3) return t('domainInterceptEvent.actionAllow')
  return '--'
}
export interface LogDataReq {
  asc?: boolean
  /** 分组id */
  group_id?: number
  /** 搜索关键词 */
  key_word?: string
  limit?: number
  page?: number
  sort?: string
  /** 开始时间 */
  start_time: number
  /** 结束时间 */
  end_time: number
  /** 策略id */
  strategy_id?: string
}

export interface LogData {
  /** 终端id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 外网IP */
  client_ip: string
  /** 内网IP */
  system_ip: string
  /** 登录状态 */
  login_status: number
  /** 所属分组名 */
  group_name: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
  /** 命中域名 */
  domain: string
  /** 命中时间 */
  intercept_time: string
  /** 触发策略 */
  strategy_name?: string
  /** 策略属性：1-黑名单，2-白名单，3-仅记录 */
  limit_type?: 1 | 2 | 3
  /** 触发动作：1、2-拦截，3-放行 */
  action?: 1 | 2 | 3
}

export interface LogDataRes {
  list?: LogData[]
  total?: number // 总数
}

@Injectable()
export class TimeViewService {
  constructor (private http: Http) {

  }


  @ParamsClean()
  @InvokeThrottle()
  getLogData (params: LogDataReq) {
    return this.http.post<LogDataRes>('/terminal/net-limit/time_list', params)
  }
  @ParamsClean([0], 1)
  download (type: 0 | 1, options: Partial<LogDataReq>, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 1, // 不分页
      limit: 9999999
    })
    return this.http.downloadWithBlob('/terminal/net-limit/time_list/export', params, moduleName)
  }
}
